import { parseISO } from 'date-fns';
import { isNaN } from 'lodash';

const parseSafeDate = (input?: string | Date | null): Date | null => {
  if (!input) {
    return null;
  }

  try {
    const parsed = typeof input === 'string' ? parseISO(input) : input;
    return isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
};

export default parseSafeDate;
